import SkipIntro from './SkipIntro';
import { VideoJsPlayer } from 'video.js';
import WatchFromStart from './WatchFromStart';
import NextEpisodeButton from './NextEpisode';
import UsePlayerProps from '../../../Store/usePlayerProps';
import { ActionBarContainer, ActionBarFlexWrapper } from '../styles';
import { useEffect, useState } from 'react';
import AdCounter from './AdCounter';

const ActionsBar = ({
  player,
}: {
  player: VideoJsPlayer
}) => {
  const playerGlobalState = UsePlayerProps((state) => state.playerState);
  const contentType = playerGlobalState.contentData?.content?.type;
  const [showStart, setShowStart] = useState(false);
  const [hasVast, setHasVast] = useState(false);

  // In an effect rather than the render body: this component mounts once the pre-roll is
  // done, and registering on every render left a one-shot listener behind per render.
  useEffect(() => {
    const onPlaying = () => setShowStart(true);
    player.one('playing', onPlaying);
    return () => player.off('playing', onPlaying);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);

  return (
    <ActionBarContainer>
      {!hasVast && showStart && <WatchFromStart player={player} />}
      <ActionBarFlexWrapper justify="flex-start" align="center" ml='auto'>
        <AdCounter player={player} hasVast={(val) => setHasVast(val)} />
        {!hasVast && contentType && playerGlobalState.showingNextEpisode && contentType === 'episode' && playerGlobalState.contentConfigs?.next_episode &&
          <NextEpisodeButton player={player} />}
        {!hasVast && playerGlobalState.contentConfigs && <SkipIntro player={player} />}
      </ActionBarFlexWrapper>
    </ActionBarContainer>
  );
};
export default ActionsBar;
